var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49886 15.006L1.76183 17.1317C0.753707 17.5899 0.753707 18.3403 1.76183 18.7985L10.2392 22.6649C11.2067 23.1054 12.7991 23.1054 13.7665 22.6649L22.2439 18.7985C23.252 18.3403 23.252 17.5899 22.2439 17.1317L17.665 14.9281M22.2393 5.21865L13.684 1.3179C12.7567 0.894033 11.2388 0.894033 10.3114 1.3179L1.76183 5.21865C0.753707 5.67689 0.753707 6.42668 1.76183 6.88492L10.2392 10.7513C11.2067 11.1924 12.7991 11.1924 13.7665 10.7513L22.2439 6.88492C23.2475 6.42668 23.2475 5.67632 22.2393 5.21865Z",
    stroke: "#606060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49885 9.04688L1.75609 11.1754C0.747969 11.6336 0.747969 12.384 1.75609 12.8422L10.2335 16.708C11.2009 17.1491 12.7933 17.1491 13.7608 16.708L22.2382 12.8422C23.252 12.384 23.252 11.6336 22.2439 11.1754L17.4966 9.04688",
    stroke: "#606060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAmount);
export default __webpack_public_path__ + "static/media/icon-amount.30b9f466920dd8703f7f8be296b4c046.svg";
export { ForwardRef as ReactComponent };